import { render, staticRenderFns } from "./oxPay.vue?vue&type=template&id=14bafee9&scoped=true"
import script from "./oxPay.vue?vue&type=script&lang=js"
export * from "./oxPay.vue?vue&type=script&lang=js"
import style0 from "./oxPay.vue?vue&type=style&index=0&id=14bafee9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bafee9",
  null
  
)

export default component.exports